// Autogenerated file
export const carsPlanningPeriodTypesEnum = {
    CurrentMonth: "CurrentMonth",
    Last10Days: "Last10Days",
    Last20Days: "Last20Days",
    Last30Days: "Last30Days",
};
export const carsPlanningPeriodTypes = [
    { label: "Текущий месяц", value: "CurrentMonth" },
    { label: "Последние 10 дней", value: "Last10Days" },
    { label: "Последние 20 дней", value: "Last20Days" },
    { label: "Последние 30 дней", value: "Last30Days" },
];
